import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import { CosmicBackground } from "@/components/cosmic/CosmicBackground";
import Hero from "./sections/Hero";
import Portals from "./sections/Portals";
import FeaturedUniverse from "./sections/FeaturedUniverse";
import MultiverseAtlas from "./sections/MultiverseAtlas";
import QuantumLab from "./sections/QuantumLab";
import WhatIfUniverse from "./sections/WhatIfUniverse";
import CosmicDiscoveries from "./sections/CosmicDiscoveries";
import UniverseCreator from "./sections/UniverseCreator";
import SimulationTheory from "./sections/SimulationTheory";
import OriginBeyond from "./sections/OriginBeyond";
import KnowledgeArchitecture from "./sections/KnowledgeArchitecture";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div className="relative min-h-[100svh] w-full max-w-full bg-background text-foreground overflow-x-clip">
      {/* Live Starfield Canvas & Drifting Nebulae - fixed behind whole page */}
      <CosmicBackground fixed accent="cyan" density={1} />

      {/* Page Content Layers */}
      <div className="relative z-10 flex flex-col min-h-[100svh] w-full max-w-full">
        <Header />
        <main className="flex-1 w-full max-w-full">
          <Hero />
          <Portals />
          <FeaturedUniverse />
          <MultiverseAtlas />
          <QuantumLab />
          <WhatIfUniverse />
          <CosmicDiscoveries />
          <UniverseCreator />
          <SimulationTheory />
          <OriginBeyond />
          <KnowledgeArchitecture />
        </main>
        <Footer />
      </div>
    </div>;
}